import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [consent, setConsent] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const consentCookie = localStorage.getItem('cookieConsent');
    if (!consentCookie) {
      setVisible(true);
    }
  }, []);

  const handleAccept = (type = 'all') => {
    const newConsent = {
      necessary: true,
      analytics: type === 'all' || type === 'analytics',
      marketing: type === 'all' || type === 'marketing'
    };
    
    localStorage.setItem('cookieConsent', JSON.stringify(newConsent));
    setConsent(newConsent);
    setVisible(false);
    
    // Initialisation des scripts en fonction du consentement
    if (newConsent.analytics) initGoogleAnalytics();
  };

  const initGoogleAnalytics = () => {
    // Votre code d'initialisation GA ici
    console.log('Analytics initialisés');
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-content">
        <p>
          Nous utilisons des cookies pour améliorer votre expérience. 
          <a href="/politique-de-confidentialite">En savoir plus</a>
        </p>
        
        <div className="cookie-buttons">
          <button 
            className="cookie-btn secondary"
            onClick={() => handleAccept('necessary')}
          >
            Refuser
          </button>
          <button 
            className="cookie-btn"
            onClick={() => handleAccept('analytics')}
          >
            Accepter les essentiels
          </button>
          <button 
            className="cookie-btn primary"
            onClick={() => handleAccept('all')}
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;